import { PageHeader } from "../../../components/AppLayout";
import { Card } from "../../../components/shared/Card";
import { EmptyState } from "../../../components/shared/EmptyState";

// Placeholder — invoices are auto-emitted by Stripe when a proposal/subscription
// payment succeeds and persisted to /invoices via the webhook handler. The
// listing UI lives here once we add `GET /admin/invoices`.
export function AdminInvoices() {
  return (
    <>
      <PageHeader
        title="Invoices"
        subtitle="Auto-emitted when a payment succeeds. Verifacti / AEAT issuance ships in Phase 6."
      />
      <Card>
        <EmptyState
          title="Coming in Phase 6"
          description="Invoices are stored via the Stripe webhook today. The global listing + Verifacti integration is pending."
        />
      </Card>
    </>
  );
}
